// app version + OTA revision. An ota-v* tag must match this value exactly.
export const CODEPUSH_VERSION = '2.0.11.0'
